import request from '@/utils/request'
import qs from 'qs'
export function getListDailyReport(query) {
  return request({
    url: '/report-service/v1/report/daily-report',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
export function getListDailyReportExcel(query) {
  return request({
    url: '/report-service/v1/report/daily-report/excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    },
    responseType: 'blob'
  })
}
